import {action, makeAutoObservable} from 'mobx';
import {RootStore} from "./index";

export type Tab = "single" | "all" | "utils" | "help";

export class StateStore {

    stores: RootStore;

    activeTab: Tab;

    activePreset: number = 0;
    lastUserSelectPreset: number;   // hack to avoid having the selector being scrolled to the top when the user click the selector (and a PC is received because we read the preset)

    importedPresets: number;    // number of imported presets
    importedConfiguration: number;    // number of imported configuration

    presetSelectorsRefs: React.RefObject<any>[] = [];

    constructor(stores: RootStore) {
        // console.log("StateStore constructor");
        makeAutoObservable(this, {
            stores: false,
            clearImportedPresets: action,
            incImportedPresets: action,
            clearImportedConfiguration: action,
            incImportedConfiguration: action,
            selectPreset: action,
            lastUserSelectPreset: false,
            presetSelectorsRefs: false
        });
        this.activeTab = "single";
        this.activePreset = 0;
        this.lastUserSelectPreset = -1;
        this.importedPresets = 0;
        this.importedConfiguration = 0;
        this.stores = stores;
    }

/*
    resetPresetSelectorsRefs() {
        // console.log("resetPresetSelectorsRefs");
        this.presetSelectorsRefs = [];
        for (let i=0; i <= 106; i++) {
            this.presetSelectorsRefs.push(React.createRef());
        }
    }
*/

    setTab(tab: Tab): void {
        this.activeTab = tab;
    }

    selectPreset(preset: number, scrollIntoView = false): void {

        console.log("state: select preset", preset);

        this.activePreset = preset;
        // if (scrollIntoView) {
        //     // console.log("selectPreset: scroll into view");
        //     // this.lastUserSelectPreset = -1;
        //     try {
        //         this.presetSelectorsRefs[preset].current.scrollIntoView({
        //             behavior: 'smooth',
        //             block: 'center',
        //             // block: 'start'
        //         });
        //     } catch (e) {
        //         // console.log("presetSelectorsRefs not yet initialized");
        //     }
        // } else {
            this.lastUserSelectPreset = preset;
        // }
    }

    clearImportedPresets(): void {
        this.importedPresets = 0;
    }

    incImportedPresets(): void {
        this.importedPresets++;
    }

    clearImportedConfiguration(): void {
        this.importedConfiguration = 0;
    }

    incImportedConfiguration(): void {
        this.importedConfiguration++;
    }

}
